import { Device } from 'ha/types/Device';
import { Actions } from '../constants';

export default function setDevice(payload: Device) {
  return {
    type: Actions.SET_DEVICE,
    payload,
  };
}
